// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ai-responsible-use.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ai-responsible-use',
  title: 'Define responsible use and human oversight of AI systems',
  description:
    'Confirm that processes for the responsible use of AI systems define the intended use, prohibited uses, the human oversight measures in place (including the ability to intervene, override or stop the system) and the competence required of operators (ISO/IEC 42001 Annex A.9.2–A.9.4). Deviations from the intended use shall trigger reassessment. Review the responsible-use standard and a sample of operator-briefing / training records.',
  category: 'governance',
  scfIds: ['SCF-AIG-011'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Responsible-use-of-AI standard is published' },
    { type: 'document-within-sla', description: 'Standard review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
